import { useContext } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';
import { VerificationContext } from '../providers';
import { ItemAllowButtons } from './ItemAllowButtons';
import { ItemAllowDate } from './ItemAllowDate';
import { ItemAllowYear } from './ItemAllowYear';

export const ItemAllow = () => {
  const { verificationMethod } = useSettings();
  const { toggleAllow } = useContext(VerificationContext);

  const Validate = {
    year: ItemAllowYear,
    buttons: ItemAllowButtons,
    date: ItemAllowDate
  }[verificationMethod];

  return (
    <Container>
      <Form>
        <Validate onClick={toggleAllow} />
      </Form>
    </Container>
  );
};

const Container = styled.div.attrs({
  className: `${meta.prefix}-item-allow-container`
})`
  display: flex;
  margin-top: 32px;
  width: 100%;
  flex-shrink: 0;
`;

const Form = styled.div.attrs({
  className: `${meta.prefix}-item-allow-form`
})`
  width: 100%;
`;
